export default __webpack_public_path__ + "static/media/gallery_04.478fd0fc.jpg";